const email_templates = state => state.email_templates
const email_template = state => state.email_template

export default {
  email_templates,
  email_template
};
